export default {

    /**
     *
     * @param params object
     *  plan_id:         string
     *  zip:             string
     *  state:           string
     *  city:            string
     *  address:         string
     *  coupon:          string
     *  oauth_client_id: string
     *  email:           string
     *
     * @returns {*}
     */
    getSubscriptionTotal: function(params) {
        return axios.get('/api/subscription/total', {
            params: params
        });
    },

    /**
     *
     * @param params object
     * plan_id: string
     * coupon:  string
     *
     * @returns {*}
     */
    validateCoupon: function(params) {
        return axios.get('/api/coupon', {
            params: params
        });
    },

    /**
     *
     * @param params object
     * phone: string
     *
     * @returns {*}
     **/
    validatePhone: function (params) {
        return axios.post('/api/validate-phone', params);
    },

    /**
     *
     * @param params
     *
     * email: string
     * address: string
     * city: string
     * state: string
     * zip: string
     * oauth_client_id: integer
     * coupon: string
     * plan_id: string
     * stripeToken: string
     * name: string
     * ip_address: string
     *
     * @returns {*}
     */
    addSubscription: function(params) {
        return axios.post('/api/subscription', params);
    },

    logSignupError: function(data) {
        return axios.post('/api/subscription/log', data);
    },

    getTerms: function(oauthClientId) {
        return axios.get('/api/subscription/terms', {
            params: {
                oauth_client_id: oauthClientId
            }
        })
    },

    getIntent: async function() {
        return axios.get('/api/subscription/payment-intent');
    },

    /**
     * Creates a setup intent for an automatic payment request (APMs)
     * @return {Promise<{ intent: { client_secret: string } } | any>}
     */
    getAutomaticPaymentIntent: async () => {
        const response = await axios.get('/subscription/setup-future-intent');

        if (response.status === 201) {
            return response.data;
        }

        return Promise.reject(response);
    },

    /**
     * Retrieves a created intent that is already consumed or tried to be used
     *
     * @param {string} setupIntentId
     * @return {Promise<{ id: string; payment_method: string; client_secret: string; }> | any}
     */
    retrieveIntent: async function(setupIntentId) {
        const response = await axios.get('/api/subscription/get-intent', { params: { setup_intent: setupIntentId } })

        if (response.status === 200) {
            return response.data;
        }

        return Promise.reject(response);
    },

    // This one requires user to be logged in
    getActiveSubscription() {
        return axios.get('/api/user/subscription');
    }
}
